module.exports = __webpack_public_path__ + "static/media/birds_fly_near_nest.e81f122e.gif";